function Governance() {
    return (
        <div className="flex min-h-full px-4 pt-6 pb-24 md:px-10">
            <div className="container mx-auto md:pt-15">
                <article className="mx-auto prose max-w-4xl prose-darkgreen">
                    <p className="text-center text-sm font-medium tracking-[0.32em] text-neutral-400 uppercase">
                        Trust & safety
                    </p>

                    <h1 className="mb-4 text-center text-6xl font-semibold tracking-wider">
                        Clinical governance.
                    </h1>

                    <p className="lead mx-auto max-w-3xl text-center text-neutral-500">
                        How we make sure every clinician on Welnido is who they
                        say they are — and safe to practise.
                    </p>

                    <h2 id="cqc-relationship" className="text-2xl font-medium">
                        Our relationship with the CQC
                    </h2>

                    <p>
                        Welnido is a booking and discovery platform — we do not
                        deliver regulated clinical care ourselves, so we are not
                        required to register with the Care Quality Commission
                        (CQC). But we hold ourselves to the standards the CQC
                        stands for. Our governance framework is deliberately
                        aligned with CQC values: care that is safe, effective,
                        caring, responsive and well-led.
                    </p>

                    <h2 id="credentially" className="text-2xl">
                        Credentially
                    </h2>

                    <p>
                        We onboard every clinician through <b>Credentially</b> —
                        specialist healthcare onboarding and compliance software
                        used across the sector. Credentially verifies
                        professional credentials at source: confirming
                        qualifications, checking registrations directly against
                        the relevant professional register, and keeping
                        compliance documents in one audited place. It also
                        tracks expiry dates automatically, so a lapsed
                        registration or document suspends a profile until it is
                        renewed. This gives every clinician on Welnido a
                        consistent, independently managed compliance record.
                    </p>

                    <h2 id="registration-checks" className="text-2xl">
                        Professional registration checks
                    </h2>

                    <p>
                        Every regulated healthcare professional in the UK holds
                        a unique registration with their professional body — the
                        GMC for doctors, the HCPC for physiotherapists and
                        allied health professionals, the NMC for nurses and
                        midwives, and the GDC for dental professionals. We check
                        each clinician's registration number against the live
                        register to confirm they are currently registered, have
                        no restrictions on their practice, and are qualified in
                        the field they list. We verify the number against the
                        register itself, not just the certificate.
                    </p>

                    <h2 id="dbs-checks" className="text-2xl">
                        DBS checks — and what they mean
                    </h2>

                    <p>
                        DBS stands for the Disclosure and Barring Service. An
                        enhanced DBS check searches a person's criminal record,
                        including spent convictions, cautions and — crucially
                        for healthcare — the barred lists of people legally
                        prohibited from working with vulnerable adults and
                        children. Every clinician on Welnido holds an enhanced
                        DBS check. This is the same level of check the NHS
                        requires, and it means the person treating you has been
                        screened to the highest standard available in the UK.
                    </p>

                    <h2 id="insurance" className="text-2xl">
                        Indemnity insurance
                    </h2>

                    <p>
                        All clinicians must hold current professional indemnity
                        insurance appropriate to their practice before going
                        live.
                    </p>
                </article>
            </div>
        </div>
    );
}

export default Governance;
